export function getTime() {
    return Date.now();
}
